export default "__VITE_ASSET__XPJfMLyq__"